import React from 'react';
import { Link } from 'react-router-dom';
import AdminDashboard from '../components/AdminDashboard';

const AdminPage: React.FC = () => {
  return (
    <div style={{
      minHeight: '100vh',
      backgroundColor: '#2c3e50',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '20px'
    }}>
      <div style={{
        width: '100%',
        maxWidth: '1200px'
      }}>
        <div style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          marginBottom: '30px'
        }}>
          <h1 style={{
            color: 'white',
            margin: 0,
            fontSize: '28px',
            fontWeight: '600'
          }}>
            🔐 Admin Dashboard
          </h1>

          <Link
            to="/"
            style={{
              color: '#4ecdc4',
              textDecoration: 'none',
              fontSize: '16px',
              fontWeight: '500'
            }}
          >
            ← Back to Home
          </Link>
        </div>

        <AdminDashboard />
      </div>
    </div>
  );
};

export default AdminPage;